import React from 'react';
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

const CustomSolution: React.FC = () => {
  return (
    <div className="text-center p-6">
      <h3 className="text-xl font-semibold mb-3">
        Not sure where to start?
      </h3>
      <p className="text-muted-foreground mb-4">
        Let's explore your challenges together and discover the perfect solution to elevate your business.
      </p>
      <Button 
        className={cn(
          "rounded-full px-8 text-white shadow-lg hover:shadow-xl transition-all duration-300",
          "bg-gradient-to-r from-purple-600 to-pink-500 hover:from-purple-700 hover:to-pink-600"
        )}
        asChild
      >
        <a href="/contact">
          Book Free Call
        </a>
      </Button>
    </div>
  );
};

export default CustomSolution;
